export const MESSAGING_LOAD_CONVERSATIONS = 'MESSAGING_LOAD_CONVERSATIONS';
export const MARK_CONVERSATIONS_READ = 'MARK_CONVERSATIONS_READ';
export const REMOVE__MESSAGE = 'REMOVE__MESSAGE';
export const SET__MESSAGE = 'SET__MESSAGE';
export const SMS__SEND = 'SMS__SEND';
export const SMS__SEND_FULFILLED = `${SMS__SEND}_FULFILLED`;
export const SMS__SEND_PENDING = `${SMS__SEND}_PENDING`;
